import { render, staticRenderFns } from "./AddPracticeUser.vue?vue&type=template&id=3c1385f4&scoped=true"
import script from "./AddPracticeUser.vue?vue&type=script&lang=js"
export * from "./AddPracticeUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1385f4",
  null
  
)

export default component.exports